import { styled } from "@mui/material/styles";
import Stack from "@mui/material/Stack";

export const StyledStack = styled(Stack)(({ theme }) => ({
  width: "100%",
  flexDirection: "row",
  justifyContent: "space-between",
  ".MuiInputBase-root": {
    padding: "8px",
    minWidth: "60px",
  },
  padding: "6px 15px",
  borderRadius: "5px",
  border: "1px solid",
  borderColor: theme.palette.hubColors.greyLight,
  backgroundColor: theme.palette.hubColors.white,
  "& .MuiTypography-root, .MuiMenuItem-root": {
    fontSize: "12px",
  },
}));
